// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pswp--img-bg-white .pswp__img {\n  background-color: white;\n}\n", ""]);
// Exports
module.exports = exports;
